export const defaultToolbarItems =
  "undo redo | blocks | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons | print code preview media";

export const templateFieldItems = "firstName lastName";

export const Toolbar = [defaultToolbarItems];

export const ToolbarWithTemplateFields = [defaultToolbarItems + " | " + templateFieldItems];
